/**
 * External dependencies
 */
import React, { memo } from 'react';
import Box from '@mui/material/Box';

/**
 * Internal dependencies
 */
import './index.css';

function Loader(): React.ReactElement {
  /* Main */
  return <Box className="loader" />;
}

export default memo(Loader);
